import { defineMessages } from 'react-intl';

const scope = 'app.components.TapToTip.Setup.ChoiceAdvisor';

export default defineMessages({
  title: {
    id: `${scope}.title`,
    defaultMessage: 'What your customer sees'
  },
  count: {
    id: `${scope}.count`,
    defaultMessage:
      '{count, plural, one {One button} other {# buttons}} on your thank-you screen.'
  },
  empty: {
    id: `${scope}.empty`,
    defaultMessage:
      'Nothing is switched on yet, so customers see no thank-you screen after they tip.'
  },
  straightThrough: {
    id: `${scope}.straightThrough`,
    defaultMessage:
      'With one choice switched on, customers go straight to it. There is no menu to read first.'
  },
  crowded: {
    id: `${scope}.crowded`,
    defaultMessage:
      'Every button here competes for the same tap. The more choices you put in front of a customer, the less likely they are to act on any of them, and Leave a review is the one you lose. Two or three is usually enough.'
  },
  reviewsOff: {
    id: `${scope}.reviewsOff`,
    defaultMessage:
      'Reviews are switched off for this screen, so none of these buttons collect one.'
  },
  guideLinks: {
    id: `${scope}.guideLinks`,
    defaultMessage: 'Guides can add links of their own to this screen from the app, on top of these.'
  },
  tourLinks: {
    id: `${scope}.tourLinks`,
    defaultMessage:
      '"{tour}" has {count} review links. Each one is another button on the review screen, so leaving the review turns into a choice of its own. Two is usually plenty.'
  },
  reviewsLabel: {
    id: `${scope}.reviewsLabel`,
    defaultMessage: 'Leave a review'
  },
  socialLabel: {
    id: `${scope}.socialLabel`,
    defaultMessage: 'Follow us on social media'
  },
  upsellLabel: {
    id: `${scope}.upsellLabel`,
    defaultMessage: 'Book another experience'
  }
});
